module.exports = __webpack_public_path__ + "img/icon-worker-1.dfbf7626.svg";